// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.thumbnail[data-v-f03ce77c] {\r\n    cursor: pointer;\r\n    display: inline-block;\r\n    height: 75px;\r\n    margin: 0px 20px 0px 20px;\r\n    opacity: 0;\r\n    transition: opacity 0.25s ease-in-out;\r\n    width: 75px;\n}\n.thumbnail.loaded[data-v-f03ce77c] {\r\n    opacity: 0.3;\n}\n.thumbnail.active[data-v-f03ce77c] {\r\n    opacity: 1;\n}\n.thumbnail .thumbnail-image[data-v-f03ce77c] {\r\n    height: 100%;\r\n    width: 100%;\n}\r\n", ""]);
// Exports
module.exports = exports;
